export default __webpack_public_path__ + "ff11a2aacbf1dd2626e12f93e2556e9d.bin";